let Vue = require('vue');
let Promise = require('bluebird');
let quickCustomer = require('sci/ui/quick-customer');

Vue.directive('quick-customer', {
    twoWay: true,
    priority: 1000,

    params: ['on-change', 'with-form'],

    bind: function () {
        let $el = $(this.el).addClass('quick-customer');

        if (this.params.withForm) {
            $el.addClass('with-form');
        }

        quickCustomer($el.parent());

        $(this.el).on('registered', (evt, data) => {
            this.set(data);
            if (this.params.onChange) {
                this.params.onChange(data);
            }
        });
    },
    update: function (value) {

    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/quick-customer.js